<div *ngIf="credolabLoading" class="text-center py-4">
    <div class="spinner-border text-primary"></div>
    <p class="mt-2 text-muted">Cargando config Credolab…</p>
</div>

<div *ngIf="!credolabLoading && credolabNotSeeded" class="alert alert-warning">
    <i class="fa fa-exclamation-triangle me-2"></i>
    <strong>Configuración no sembrada.</strong>
    Ejecute <code>node seed_approval_policy.js</code> en kredit-api-MT.
</div>

<div *ngIf="!credolabLoading && !credolabNotSeeded && credolabData" class="card">
    <div class="card-body">
        <div class="row g-3">
            <div class="col-md-4">
                <label class="form-label fw-bold">Score mínimo <small class="text-muted">(0-1000)</small></label>
                <input type="number" class="form-control"
                       [(ngModel)]="thresholdsForm.minScore"
                       min="0" max="1000" step="1"
                       [disabled]="credolabSaving || thresholdsForm.evaluationMode === 'PROBABILITY_ONLY'">
                <small class="form-text text-muted">
                    <ng-container *ngIf="thresholdsForm.evaluationMode !== 'PROBABILITY_ONLY'; else scoreIgnored">
                        Credolab aprueba si el score es ≥ a este valor.
                    </ng-container>
                    <ng-template #scoreIgnored>
                        <i class="fa fa-info-circle me-1"></i> No se usa en modo "Solo probabilidad".
                    </ng-template>
                </small>
            </div>
            <div class="col-md-4">
                <label class="form-label fw-bold">Probabilidad máxima <small class="text-muted">(0-1)</small></label>
                <input type="number" class="form-control"
                       [(ngModel)]="thresholdsForm.maxProbability"
                       min="0" max="1" step="0.01"
                       [disabled]="credolabSaving || thresholdsForm.evaluationMode === 'SCORE_ONLY'">
                <small class="form-text text-muted">
                    <ng-container *ngIf="thresholdsForm.evaluationMode !== 'SCORE_ONLY'; else probIgnored">
                        Credolab aprueba si la probabilidad de default es ≤ a este valor.
                    </ng-container>
                    <ng-template #probIgnored>
                        <i class="fa fa-info-circle me-1"></i> No se usa en modo "Solo score".
                    </ng-template>
                </small>
            </div>
            <div class="col-md-4">
                <label class="form-label fw-bold">Modo de evaluación</label>
                <select class="form-select"
                        [(ngModel)]="thresholdsForm.evaluationMode"
                        [disabled]="credolabSaving">
                    <option [ngValue]="'BOTH'">Ambos umbrales deben pasar</option>
                    <option [ngValue]="'EITHER'">Basta con que uno pase</option>
                    <option [ngValue]="'SCORE_ONLY'">Solo score decide</option>
                    <option [ngValue]="'PROBABILITY_ONLY'">Solo probabilidad decide</option>
                </select>
                <small class="form-text text-muted">Define qué umbral(es) gobiernan el resultado de Credolab.</small>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <small class="text-muted">
                    Última modificación:
                    <strong>{{ credolabData.updatedBy || '—' }}</strong>
                    el <strong>{{ credolabData.updatedAt | date:'dd/MM/yyyy HH:mm' }}</strong>
                </small>
            </div>
        </div>

        <button class="btn btn-primary mt-3"
                (click)="saveThresholds()"
                [disabled]="credolabSaving">
            <span *ngIf="credolabSaving" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!credolabSaving" class="fa fa-save me-1"></i>
            Guardar umbrales
        </button>
    </div>
</div>
